import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import PageWrapper from 'components/Common/PageWraper';
import PageHeader from 'components/Header/Page';

export default function DemoDashboardHome() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <PageWrapper>
      <PageHeader title="Components Library" />

      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/pie')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Pie, Doughnut & Gauge Charts - 6</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/bar')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Bar Charts - 2</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/table')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Tables - 1</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/collapsible-menu')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Collapsible Menu</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/metric-cards')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Metric Cards</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/kpi-tiles')}
            >
              <CardContent>
                <Typography variant="widgetTitle">KPI Tiles</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/lineCharts')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Area - Line charts</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/metricCountWidgets')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Metric Count widgets</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/AdvanceFilters')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Filters</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/program-cards')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Program Cards</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/tabular-view')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Tabular View</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/kpi-program-cards')}
            >
              <CardContent>
                <Typography variant="widgetTitle">
                  Accordion, KPI Metric Cards and Tooltips
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/form-inputs')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Form Input Fields</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/rich-text-editor')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Rich Text Editor</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/modals')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Modals & Overlays</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardActionArea
              sx={{ backgroundColor: colors.backgroundLight.dark }}
              onClick={() => navigate('/demo-dashboard/buttons')}
            >
              <CardContent>
                <Typography variant="widgetTitle">Buttons, Toggle & Checkbox</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
